// @flow
import { RESORT_RECOMMENDATIONS } from 'Client/cms/toolkit/constants';
import { ProductRecommendationsLine } from 'Components/lines/product-recommendations-line/ProductRecommendationsLine';
import { productRecommendationsResolver } from './productRecommendations.resolver';

export const productRecommendationsDescriptor = {
  name: RESORT_RECOMMENDATIONS,
  component: ProductRecommendationsLine,
  resolve: productRecommendationsResolver.resolve,
};
